import React from 'react';
import {Redirect, Route} from 'react-router-dom';

// handle the public routes
function PublicRoute({ loggedIn, setLogin, location, component: Component, ...rest }) {
  const searchParams = new URLSearchParams(location.search) ;
  let logAgain = false ;
  if (searchParams.get("usr") !== null && searchParams.get("pwd") !== null && searchParams.get("base") !== null){
    logAgain = true ;
  }
  return (
    <Route
      {...rest}
      render={(props) => loggedIn === false || logAgain === true ? <Component {...props} setLogin={setLogin} /> : <Redirect to={{ pathname: '/accueil' }} />}
    />
  )
}

export default PublicRoute;
